/**
 * Global Functions
 * These can be called from anywhere (e.g., onclick attributes)
 */

// Scroll to a specific H3 heading by its text content
function scrollToH3ByText(targetText) {
  const headings = document.querySelectorAll('h3');
  const targetHeading = Array.from(headings).find(h3 => 
    h3.textContent.trim() === targetText
  );

  if (targetHeading) {
    targetHeading.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  } else {
    console.warn(`Heading with text "${targetText}" not found.`);
  }
}

/**
 * Custom Elements Definitions
 */

class DaylyItem extends HTMLElement {
  constructor() {
    super();
  }

  // Best practice: setup listeners in connectedCallback
  connectedCallback() {
    const dailyHeading = this.querySelector('.daily-essentials__container');
    const dailyContent = this.querySelector('.card__caption-wrapper');

    if (dailyHeading && dailyContent) {
      dailyHeading.addEventListener('click', (event) => {
        event.preventDefault();
        dailyContent.classList.toggle('is-open');
        dailyHeading.classList.toggle('is-open');
      });
    }
  }
}



/**
 * Feature Initializers
 */

// Handles Swiper initialization for related products on mobile/tablet
function initResponsiveSwiper() {
  const sliderElement = document.querySelector('.js-article-related-products');
  if (!sliderElement) return;

  const screenWidth = window.innerWidth;

  if (screenWidth < 1025) {
    if (!sliderElement.swiper) {
      new Swiper(sliderElement, {
        slidesPerView: 'auto',
        spaceBetween: 15,
      });
    }
  } else {
    if (sliderElement.swiper) {
      sliderElement.swiper.destroy(true, true);
    }
  }
}

// Wraps native videos with a custom play overlay
function initVideoWrappers() {
  const videos = document.querySelectorAll('.article-microbiome-content-left video');

  videos.forEach(video => {
    // Skip if already wrapped
    if (video.parentElement.classList.contains('video-wrapper')) return;

    // Create Wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'video-wrapper';
    video.parentNode.insertBefore(wrapper, video);
    wrapper.appendChild(video);

    // Create Overlay
    const overlay = document.createElement('div');
    overlay.classList.add('video-overlay-icon');
    overlay.innerHTML = `
      <svg class="icon icon-play" aria-hidden="true" focusable="false" width="60" height="60" viewBox="0 0 60 60">
        <path d="M42.682 28.265a2 2 0 0 1 0 3.473l-19.068 10.9a2 2 0 0 1-2.993-1.741V19.105a2 2 0 0 1 2.994-1.736Z" fill="#fff"></path>
      </svg>
    `;
    wrapper.appendChild(overlay);
    
    video.removeAttribute('controls');

    // Click behavior
    wrapper.addEventListener('click', () => {
      if (video.paused) {
        video.play();
      } else {
        // video.pause(); // Standardized: clicking while playing pauses the video
      }
    });

    // Event Listeners for UI updates
    video.addEventListener('play', () => {
      video.setAttribute('controls', 'true');
      overlay.style.display = 'none';
    });

    video.addEventListener('pause', () => {
      video.removeAttribute('controls');
      overlay.style.display = 'block';
    });

    video.addEventListener('ended', () => {
      video.removeAttribute('controls');
      overlay.style.display = 'block';
    });
  });
}

/**
 * Event Listeners for Orchestration
 */

document.addEventListener('DOMContentLoaded', () => {
  initVideoWrappers();
  initResponsiveSwiper(); // Initial check
    // Define the custom element immediately
    if (!customElements.get('dayly-item')) {
        customElements.define('dayly-item', DaylyItem);
    }
});

// Use 'resize' for swiper responsiveness
window.addEventListener('resize', initResponsiveSwiper);